import { put, takeLatest } from 'redux-saga/effects';
import { TaskAPI } from 'api/tasks';
import { logger } from 'services';
import { fetchTaskSaga, saveTaskDetailSaga } from '../actions';
import { fetchTaskDetailStart, fetchTaskDetailError } from '../slice';
function* getTaskByIdSaga(action) {
    const { projectId, taskId, fetchInBackground, onSuccess } = action.payload;
    try {
        if (!fetchInBackground) {
            yield put(fetchTaskDetailStart(taskId));
        }
        const task = yield TaskAPI.getTask(projectId, taskId);
        /* when get DELETED task, backend will return 204: no content. So adding condition for safety */ if (task) {
            if (onSuccess) {
                onSuccess(task);
            }
            yield put(saveTaskDetailSaga(task));
        }
    } catch (error) {
        logger.error('getTaskByIdSaga failed', {
            error
        });
        yield put(fetchTaskDetailError(taskId));
    }
}
export const watchGetTaskByIdSaga = function*() {
    yield takeLatest(fetchTaskSaga.type, getTaskByIdSaga);
};
